import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './controlinterno.css';

const ControlInterno = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="ci-banner">
        <img
          className="ci-banner__deco ci-banner__deco--left"
          src="/micro/back_1.png"
          alt="Decoración izquierda"
        />

        <div className="ci-banner__center">
          <img
            className="ci-banner__logo"
            src="/micro/logo_micro.png"
            alt="Logo Contraloría Hidalgo"
          />
          <p className="ci-banner__org">CONTRALORÍA</p>
          <p className="ci-banner__sub">SECRETARÍA DE CONTRALORÍA</p>
          <p className="ci-banner__title">MICROSITIO</p>
          <p className="ci-banner__title">SISTEMA DE CONTROL INTERNO</p>
        </div>

        <img
          className="ci-banner__deco ci-banner__deco--right"
          src="/micro/back_2.png"
          alt="Decoración derecha"
        />
      </div>

      {/* ── NAVIGATION BUTTONS ── */}
      <div className="container ci-nav justify-content-center d-flex">
        <Link to="/ControlInterno/Micrositio" className="ci-nav__btn" style={{ maxWidth: '400px' }}>
          <div className="ci-nav__icon">
            <i className="fa-solid fa-arrow-right-to-bracket"></i>
          </div>
          <span className="ci-nav__label">Ingresar</span>
        </Link>
      </div>
    </>
  );
};

export default ControlInterno;